import { FormattedMessage } from "react-intl";

import { AssetState } from "__graphql__/types";
import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

type ReportBatteryLostModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
  newStatus: AssetState;
};

export function ReportBatteryLostModal({
  isOpen,
  onClose,
  onClickPrimary,
  onClickSecondary,
  newStatus = AssetState.asset_state_lost,
}: ReportBatteryLostModalProps) {
  const newStatusLabel = newStatus === AssetState.asset_state_lost ? "lost" : "stolen";
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage
              id="pages.inventory.battery-management.modals.report-battery-lost.title"
              values={{
                newStatus: newStatusLabel,
              }}
            />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage
              id="pages.inventory.battery-management.modals.report-battery-lost.description"
              values={{
                newStatus: newStatusLabel,
              }}
            />
          </BodyM>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button onClick={onClickPrimary} variant="primary" size="lg" isFullWidth>
            <FormattedMessage
              id="pages.inventory.battery-management.modals.report-battery-lost.cta.primary"
              values={{
                newStatus: newStatusLabel,
              }}
            />
          </Button>
          <Button onClick={onClickSecondary} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="pages.inventory.battery-management.modals.report-battery-lost.cta.secondary" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
